import { FormItem } from './hd-form/hd-form.service';
import { round } from 'lodash';
// 工具类
export const Utils = {
  /**
   * 填充select控件选项
   * @param formList 入参数组 Array<any>
   * @param name 需要填充options的属性名称
   * @param options 选项列表
   */
  fillSelectOption(formList: Array<any>, name: string, options: Array<any>) {
    const returnData = formList;
    if (!returnData || !returnData.length) {
      return returnData;
    }
    const length = formList.length;
    for (let i = 0; i < length; i++) {
      if (returnData[i].name === name) {
        returnData[i].selectOption.selectList = options;
      }
    }
    return returnData;
  },

  /**
   * 填充FormItem数组：针对入参list的每一个FormItem，判断obj中是否有对应的name字段，如果有，则填充value。
   * @param list 入参数组 Array<FormItem>
   * @param obj 需要填充到list的属性
   */
  fillArrayFormItem(list: Array<FormItem>, obj: Object) {
    const returnData = [];
    if (!list || !list.length) {
      return returnData;
    }
    const length = list.length;
    for (let i = 0; i < length; i++) {
      if (obj[list[i].name]) {
        list[i].value = obj[list[i].name];
      }
    }
    return list;
  },

  /**
   * 数组转换成选择器的选项数组
   * @param list 入参数组 字符串数组或对象数组
   * @param option 转换选项
   * 注：list为字符串数组，option不需要传，按照标准的label、value转换
   */
  arrayToSelectOptionList(list: Array<any>, option?: {
    value: string,
    label: string,
    valueTip?: string,
    labelTip?: string
  }) {
    const returnData = [];
    if (!list || !list.length) {
      return returnData;
    }
    if (option) {
      if (option.labelTip && option.valueTip) {
        list.forEach((item) => {
          const returnItem: any = item;
          returnItem.label = item[option.label];
          returnItem.value = item[option.value];
          if (option.valueTip) {
            returnItem[option.valueTip] = item[option.value];
          }
          if (option.labelTip) {
            returnItem[option.labelTip] = item[option.label];
          }
          returnData.push(returnItem);
        });
      } else {
        list.forEach((item) => {
          const returnItem: any = item;
          returnItem.label = item[option.label];
          returnItem.value = item[option.value];
          returnData.push(returnItem);
        });
      }
    } else {
      list.forEach((item) => {
        const returnItem: any = {};
        returnItem.label = item;
        returnItem.value = item;
        returnData.push(returnItem);
      });
    }
    return returnData;
  },

  /**
   * 求和
   * @param nums 数组
   * @param precision 精度
   */
  add(nums: number[], precision: number = 2) {
    if (!Array.isArray(nums)) {
      throw new Error('参数必须是数组');
    }
    if (nums.some(num => typeof num !== 'number')) {
      throw new Error('数组元素必须是数字');
    }
    let result = 0;
    for (const num of nums) {
      result += num;
    }
    return round(result, precision);
  },

  /**
   * 减法
   * @param nums 数组
   * @param precision 精度
   */
  subtract(nums: number[], precision: number = 2) {
    if (!Array.isArray(nums)) {
      throw new Error('参数必须是数组');
    }
    if (nums.some(num => typeof num !== 'number')) {
      throw new Error('数组元素必须是数字');
    }
    if (nums.length < 2) {
      throw new Error('减法入参数量至少要2个！');
    }
    let result = nums.shift();
    for (const num of nums) {
      result -= num;
    }
    return round(result, precision);
  },

  /**
   * 乘法
   * @param nums 数组
   * @param precision 精度
   */
  multiply(nums: number[], precision: number = 2) {
    if (!Array.isArray(nums)) {
      throw new Error('参数必须是数组');
    }
    if (nums.some(num => typeof num !== 'number')) {
      throw new Error('数组元素必须是数字');
    }
    let result = 1;
    for (const num of nums) {
      result = result * num;
    }
    return round(result, precision);
  },

  /**
   * 除法
   * @param nums 数组
   * @param precision 精度
   */
  divide(nums: number[], precision: number = 2) {
    if (!Array.isArray(nums)) {
      throw new Error('参数必须是数组');
    }
    if (nums.some(num => typeof num !== 'number')) {
      throw new Error('数组元素必须是数字');
    }
    if (nums.length < 2) {
      throw new Error('除法入参数量至少要2个！');
    }
    let result = nums.shift();
    for (const num of nums) {
      if (num === 0) {
        throw new Error('除数不能为0！');
      }
      result = result / num;
    }
    return round(result, precision);
  }
};
